// Action Imports
import { analyzeDoc } from "../../../actions/DocumentActions";
import { getMeterUsageService } from "../../../actions/CommonActions/commonService";

// Internal Imports
import store from "../../../store";
import { DOCUMENT_STAGES } from "../Constants";
import { BILLING } from "../../../constants";

export const isEsignLimitExceeded = ({ payload }) =>
  getMeterUsageService(BILLING.BILLINGS_ENTITY_CONSUMPTION_POINT.E_SIGN)
    .then(res => {
      if (res) {
        const { limit, usage } = res;
        if (limit <= usage) {
          payload.break = true;
          payload.esignUsageLimit = res;
          payload.viewToShow = "showEsignLimitExceedModal";
        }
      }
    })
    .catch(err => {
      console.error(`eSignMethod.js => isEsignLimitExceeded => ${err}`);
    });

export const isDocRenameRequired = ({ payload }) => {
  if (
    payload.documentName === "Untitled Document" &&
    !payload.skipDocNameCheck &&
    payload.documentStage === DOCUMENT_STAGES.DRAFT
  ) {
    payload.break = true;
    payload.skipDocNameCheck = true;
    payload.viewToShow = "showDocRenameModal";
  }
};

export const showEsignWarning = ({ payload }) => {
  if (
    !payload.isSignersCheckListValid &&
    payload.documentStage === DOCUMENT_STAGES.DRAFT
  ) {
    payload.break = true;
    payload.viewToShow = "showEsignWarning";
  }
};

export const showUnfilledFormFieldWarning = ({ payload }) => {
  if (payload.isFormMode && !payload.skipFormFieldsFilledCheck) {
    const isAllFieldsFilled = payload.formFields.every(
      item =>
        (item.value && Object.values(item.value).every(value => value)) ||
        (item.meta && item.meta.default),
    );
    if (!isAllFieldsFilled) {
      payload.break = true;
      payload.skipFormFieldsFilledCheck = true;
      payload.viewToShow = "showUnFilledFormFieldsWarningModal";
    }
  }
};

export const isApprovalRequired = ({ payload }) => {
  if (payload.documentStage === DOCUMENT_STAGES.DRAFT) {
    return store
      .dispatch(
        analyzeDoc({
          event_id: payload.workFlowEventID,
          entity: "DEAL",
          entity_id: payload.documentID,
        }),
      )
      .then(response => {
        if (response.Analysis && response.Analysis.length > 0) {
          payload.break = true;
          payload.viewToShow = "showApprovalModal";
        } else {
          payload.break = true;
          payload.viewToShow = "showSignerDetailsModal";
        }
      })
      .catch(err =>
        console.error(`eSignMethod.js => isApprovalRequired => ${err}`),
      );
  }
  if (payload.documentStage === DOCUMENT_STAGES.APPROVED) {
    if (payload.isSignersCheckListValid) {
      payload.break = true;
      payload.viewToShow = "showSignerDetailsModal";
    } else {
      payload.break = true;
      payload.viewToShow = "showEsignWarningOnApprovedStagePopup";
    }
  }
  return true;
};

export const showDocStatusUpdate = ({ payload }) => {
  if (
    !payload.skipDocStatusUpdate &&
    payload.documentStage === DOCUMENT_STAGES.SENT
  ) {
    payload.break = true;
    payload.skipDocStatusUpdate = true;
    payload.viewToShow = "showDocStatusUpdateModal";
  }
  return true;
};

export const showDocFillerStatusUpdate = ({ payload }) => {
  if (
    !payload.skipDocStatusUpdate &&
    payload.documentStage === DOCUMENT_STAGES.SENT_FOR_FILLING
  ) {
    payload.break = true;
    payload.skipDocStatusUpdate = true;
    payload.viewToShow = "showEsignFillerDocStatusUpdateModal";
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Methods/eSignMethod.js